import React, { useEffect } from "react";
import isEmpty from "lodash/isEmpty";
import Alert from "react-s-alert";

import { paths, RESPONSE_STATUS, STATUS_TYPE } from "utils/constants";
import { getChannelFromUrl, gotoUrl } from "utils/helpers";
import { Flex } from "ui-components";
import Spinner, { styles } from "components/Spinner";
import PaymentAdyenDropin from "components/PaymentAdyenDropin";

// upfront payment components mainly use OrderSummary container, while update payment component
// use orderSessionToken in upfront payment component we use token from order summary container.
function PaymentUpfrontAdyenDropIn({
  isFetchingPaymentDetails,
  paymentDetails,
  fetchUpfrontPaymentDetails,
  processUpfrontPayment,
  token
}) {
  const channel = getChannelFromUrl();
  const paymentReturnPath = paths.PAYMENT_RETURN.replace(":channel", channel);
  const loading = isEmpty(paymentDetails) || isFetchingPaymentDetails;

  useEffect(() => {
    if (isEmpty(paymentDetails) && !isFetchingPaymentDetails && token) {
      fetchUpfrontPaymentDetails({
        token
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (state, dropin) => {
    const {
      data: { paymentMethod, browserInfo, riskData }
    } = state;
    let payload = {
      paymentMethod,
      browserInfo,
      riskData,
      origin: window.location.origin,
      channel: "Web",
      instrument_data: {
        redirect_url: `${window.location.origin}${paths.PAYMENT_STATUS.replace(
          ":channel",
          channel
        )}?type=${STATUS_TYPE.TRANSACTION}`
      },
      token
    };

    dropin.setStatus("loading");

    processUpfrontPayment(payload, (result, error) => {
      if (
        result?.status === RESPONSE_STATUS.SUBMITTED &&
        result?.action_object
      ) {
        dropin.handleAction(result.action_object);
      } else if (result?.status === RESPONSE_STATUS.SUCCESS) {
        // if adyen didn't trigger the 3ds flow and if the payment is a success redirect user to the payment status page and it will show the success page.
        gotoUrl(
          paths.PAYMENT_STATUS.replace(":channel", channel),
          true,
          { type: STATUS_TYPE.TRANSACTION },
          false
        );
      } else {
        dropin.setStatus("ready");
        Alert.error(
          `Payment unsuccessful please try again. (${result.error_message})`
        );
      }
    });
  };

  return (
    <Flex minHeight={"282px"} alignItems={"center"} justifyContent={"center"}>
      {loading ? (
        <Spinner size={200} sx={styles.modalContainer} />
      ) : (
        <PaymentAdyenDropin
          paymentRequestData={paymentDetails}
          returnUrl={paymentReturnPath}
          loading={loading}
          onSubmit={onSubmit}
        />
      )}
    </Flex>
  );
}

export default PaymentUpfrontAdyenDropIn;
